import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';

const AppleCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    handleAppleCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAppleCallback = async () => {
    try {
      // URL fragment에서 파라미터 추출
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const queryParams = new URLSearchParams(location.search);

      // id_token은 fragment 또는 query에서 올 수 있음
      const idToken = hashParams.get('id_token') || queryParams.get('id_token');
      const code = hashParams.get('code') || queryParams.get('code');
      const error = hashParams.get('error') || queryParams.get('error');

      console.log('[AppleCallback] 시작');
      console.log('[AppleCallback] id_token:', idToken ? '존재' : '없음');
      console.log('[AppleCallback] code:', code ? '존재' : '없음');

      if (error) {
        console.error('[AppleCallback] 에러:', error);
        alert('Apple 로그인이 취소되었습니다.');
        navigate('/login', { replace: true });
        return;
      }

      if (!idToken) {
        console.error('[AppleCallback] id_token이 없습니다');
        alert('Apple 로그인에 실패했습니다.');
        navigate('/login', { replace: true });
        return;
      }

      // JWT 디코딩 (id_token에서 사용자 정보 추출)
      const payload = parseJwt(idToken);
      console.log('[AppleCallback] JWT payload:', payload);

      if (!payload || !payload.sub) {
        console.error('[AppleCallback] 유효하지 않은 토큰');
        alert('Apple 로그인에 실패했습니다.');
        navigate('/login', { replace: true });
        return;
      }

      const snsId = `apple_${payload.sub}`;
      const email = payload.email || '';
      // Apple은 첫 로그인 시에만 이름을 제공하고, 이후에는 제공하지 않음
      const name = '';

      console.log('[AppleCallback] SNS ID:', snsId);
      console.log('[AppleCallback] Email:', email);

      // 1. Supabase Auth 세션 생성
      console.log('[AppleCallback] Supabase Auth 세션 생성 중...');
      await login(snsId);
      console.log('[AppleCallback] Supabase Auth 세션 생성 완료');

      // 2. DB에서 기존 회원 확인
      console.log('[AppleCallback] DB 조회 시작...');
      const { data: existingCustomer, error: dbError } = await supabase
        .from('customers')
        .select('*')
        .ilike('sns_id', snsId)
        .maybeSingle();

      console.log('[AppleCallback] DB 조회 완료:', existingCustomer ? '회원 존재' : '회원 없음', dbError);

      if (existingCustomer) {
        console.log('[AppleCallback] 기존 회원:', existingCustomer.nickname);
        navigate('/main', { replace: true });
      } else {
        console.log('[AppleCallback] 신규 회원 - 회원가입 진행');
        navigate('/signup/phone-verification', {
          replace: true,
          state: {
            snsType: 'apple',
            snsId,
            email,
            name,
          },
        });
      }
    } catch (error) {
      console.error('[AppleCallback] 처리 오류:', error);
      alert('Apple 로그인 중 오류가 발생했습니다.');
      navigate('/login', { replace: true });
    }
  };

  // JWT 디코딩 함수
  const parseJwt = (token: string) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('[AppleCallback] JWT 파싱 오류:', e);
      return null;
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#1e1e1e',
        color: '#ffffff',
        fontFamily: 'SUIT, sans-serif',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <h2>Apple 로그인 처리 중...</h2>
        <p>잠시만 기다려주세요.</p>
      </div>
    </div>
  );
};

export default AppleCallback;
